var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mb-5"},[_c('label',{staticClass:"mb-2"},[_vm._v("Opacity")]),_c('vue-slider',{staticClass:"editor-slider-2",attrs:{"interval":0.1,"dot-size":17,"tooltip":"none","min":0,"max":1},model:{value:(_vm.config.opacity),callback:function ($$v) {_vm.$set(_vm.config, "opacity", $$v)},expression:"config.opacity"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }